"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default(palette) {
  return {
    td: {
      palette: palette,
      borderTop: "0 none",
      borderBottom: "1px solid ".concat(palette.elDivider),
      borderLeft: "0 none",
      borderRight: "0 none",
      fontSize: palette.tsSmall,
      lineHeight: palette.tlSmall,
      textAlign: 'left',
      verticalAlign: 'middle',
      boxSizing: 'border-box',
      color: palette.tFilled,
      background: 'transparent',
      paddingTop: palette.gutter + 'px',
      paddingBottom: palette.gutter + 'px',
      paddingLeft: palette.gutter + 'px',
      paddingRight: palette.gutter + 'px',
      height: '60px',
      transitionDuration: palette.transitionDuration,
      transitionTimingFunction: palette.transitionFunction,
      transitionProperty: 'background'
    },
    th: {
      palette: palette,
      borderTop: "0 none",
      borderBottom: "0 none",
      borderLeft: "0 none",
      borderRight: "0 none",
      fontSize: palette.tsXSmall,
      lineHeight: palette.tlXSmall,
      textAlign: 'left',
      verticalAlign: 'middle',
      boxSizing: 'border-box',
      color: palette.tInactive,
      background: palette.elPrimaryLight,
      paddingTop: palette.gutter + 'px',
      paddingBottom: palette.gutter + 'px',
      paddingLeft: palette.gutter + 'px',
      paddingRight: palette.gutter + 'px',
      fontWeight: palette.twSemi,
      transitionDuration: palette.transitionDuration,
      transitionTimingFunction: palette.transitionFunction,
      transitionProperty: 'background'
    },
    tr: {
      palette: palette,
      background: 'transparent',
      hoverCursor: 'pointer',
      hoverBackground: palette.elPrimaryLight
    },
    tbody: {
      zebraBackground: palette.elPrimaryLight
    },
    tbh: {
      palette: palette,
      borderTop: "0 none",
      borderBottom: "1px solid ".concat(palette.elDivider),
      borderLeft: "0 none",
      borderRight: "0 none",
      fontSize: palette.tsXSmall,
      lineHeight: palette.tlXSmall,
      textAlign: 'left',
      verticalAlign: 'middle',
      boxSizing: 'border-box',
      color: palette.tInactive,
      background: palette.elLightest,
      paddingTop: "".concat(palette.gutter / 2, "px"),
      paddingBottom: "".concat(palette.gutter / 2, "px"),
      paddingLeft: palette.gutter + 'px',
      paddingRight: palette.gutter + 'px',
      fontWeight: palette.twNormal,
      transitionDuration: palette.transitionDuration,
      transitionTimingFunction: palette.transitionFunction,
      transitionProperty: 'background'
    },
    table: {
      palette: palette,
      borderCollapse: 'separate',
      borderSpacing: 0,
      width: '100%',
      minWidth: 'auto'
    },
    tfoot: {
      palette: palette
    },
    thead: {
      palette: palette
    }
  };
}